import PropTypes from 'prop-types';
import UIAlert from 'UIComponents/alert/UIAlert';
import { ApprovalErrorAlertI18nTitle, ApprovalErrorAlertI18nMessage } from './i18n/ApprovalErrorAlertI18n';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalErrorAlert({
  approvalType,
  className = 'm-bottom-5',
  errorSubCategory
}) {
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx(ApprovalErrorAlertI18nTitle, {
      approvalType: approvalType,
      errorSubCategory: errorSubCategory
    }),
    className: className,
    children: /*#__PURE__*/_jsx(ApprovalErrorAlertI18nMessage, {
      approvalType: approvalType,
      errorSubCategory: errorSubCategory
    })
  });
}
ApprovalErrorAlert.propTypes = {
  errorSubCategory: PropTypes.string
};
export default ApprovalErrorAlert;